/*eslint-disable*/
export default instagramContainer => {
// JS to overide Curalate's default overlay. It's based on timeouts, which isn't great, but it effectively works around Curalate's attempts to prevent custom css
// Currently the default overlay class .zpu7ru-0 is set to display:none!important, but in case they change the class name, the JS will handle hiding the div until we figure out the new class name
  $(document).ready(() => {
    setTimeout(() => {
      hideDefaultOverlay(instagramContainer)
      $('button[aria-label="Previous slide - Media Carousel"], button[aria-label="Next slide - Media Carousel"]').on('click', () => {
        setTimeout(() => { hideDefaultOverlay(instagramContainer) }, 500)
      })
    }, 2000)
  })

  $(window).on('resize', () => hideDefaultOverlay(instagramContainer))

  const hideDefaultOverlay = container => {
    $(container).find('.insta-image-container').find('div[role="list"]').children().each((idx, imageContainer) => {
      $(imageContainer).addClass('insta-carousel-item').hover((evt) => {
        $(evt.currentTarget).find('button').children().length === 2 &&
        $($(evt.currentTarget).find('button').children()[0]).addClass('hidden')
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/instagram.js